export const getUniqueId = () => {
  return Number(Math.random().toString().substr(3, 20) + Date.now()).toString(36);
};
